import { render, staticRenderFns } from "./courses-encite-item.vue?vue&type=template&id=cff7031a&scoped=true"
import script from "./courses-encite-item.vue?vue&type=script&lang=js"
export * from "./courses-encite-item.vue?vue&type=script&lang=js"
import style0 from "./courses-encite-item.vue?vue&type=style&index=0&id=cff7031a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff7031a",
  null
  
)

export default component.exports